// navbar 页面跳转意图
export enum NavIntentEnums {
  // 臻有钱首页
  financeHome = 'financeH5_home',
  // 臻有钱我的页
  financeMyProfile = 'financeH5_myProfile',
  // 臻有钱我的页
  financeMember = 'financeH5_member',
}
